import React, { useState } from 'react';
import PropTypes from 'prop-types';
import EHersEnrollmentStep1 from './EHersEnrollmentStep1';
import EHersEnrollmentStep2 from './EHersEnrollmentStep2';
import EHersEnrollmentStep3 from './EHersEnrollmentStep3';

// eslint-disable-next-line max-lines-per-function
const EHersEnrollmentSite = ({
  initialStep,
  initialEncAccountId,
  initialEncServiceLocationId,
  initialEncExternalAccountId,
  initialDisplayAccountId,
  initialStreetAddress,
  initialLastName,
  initialZipCode,
  initialEmail,
}) => {
  const [step, setStep] = useState(initialStep);
  const [step2Data, setStep2Data] = useState({
    encAccountId: initialEncAccountId,
    encServiceLocationId: initialEncServiceLocationId,
    encExternalAccountId: initialEncExternalAccountId,
    displayAccountId: initialDisplayAccountId,
    streetAddress: initialStreetAddress,
    lastName: initialLastName,
    zipCode: initialZipCode,
    email: initialEmail,
  });

  /**
   *
   * @param {{streetAddress: string, lastName: string, zipCode: string}} enteredInfo
   * @param {EHersCheckEligibilityResponse} eligibilityResponse
   */
  const handleEligibilitySuccess = (enteredInfo, eligibilityResponse) => {
    setStep(2);
    setStep2Data({
      encAccountId: eligibilityResponse.encAccountId,
      encServiceLocationId: eligibilityResponse.encServiceLocationId,
      encExternalAccountId: eligibilityResponse.encExternalAccountId,
      displayAccountId: eligibilityResponse.displayAccountId,
      streetAddress: eligibilityResponse.address || enteredInfo.streetAddress,
      lastName: eligibilityResponse.lastName || enteredInfo.lastName,
      email: enteredInfo.email,
      zipCode: enteredInfo.zipCode,
      // email: eligibilityResponse.email,
    });
  };

  const handleEnrollmentSuccess = () => {
    setStep(3);
  };

  return (
    <>
      {step === 1 && (
        <EHersEnrollmentStep1
          onSuccess={handleEligibilitySuccess}
        />
      )}
      {step === 2 && (
        <EHersEnrollmentStep2
          onSuccess={handleEnrollmentSuccess}
          encAccountId={step2Data.encAccountId}
          encServiceLocationId={step2Data.encServiceLocationId}
          encExternalAccountId={step2Data.encExternalAccountId}
          displayAccountId={step2Data.displayAccountId}
          streetAddress={step2Data.streetAddress}
          lastName={step2Data.lastName}
          zipCode={step2Data.zipCode}
          email={step2Data.email}
        />
      )}
      {step === 3 && (
        <EHersEnrollmentStep3 />
      )}
    </>
  );
};

EHersEnrollmentSite.propTypes = {
  initialStep: PropTypes.number,
  initialEncAccountId: PropTypes.string,
  initialEncServiceLocationId: PropTypes.string,
  initialEncExternalAccountId: PropTypes.string,
  initialDisplayAccountId: PropTypes.string,
  initialEmail: PropTypes.string,
  initialStreetAddress: PropTypes.string,
  initialLastName: PropTypes.string,
  initialZipCode: PropTypes.string,
};

EHersEnrollmentSite.defaultProps = {
  initialStep: 1,
  initialEncAccountId: '',
  initialEncServiceLocationId: '',
  initialEncExternalAccountId: '',
  initialDisplayAccountId: '',
  initialStreetAddress: '',
  initialLastName: '',
  initialZipCode: '',
  initialEmail: '',
};

export default EHersEnrollmentSite;
